import { defineMessage } from 'react-intl';

var cancelMessage = defineMessage({ id: "SNyjv/", defaultMessage: [{ type: 0, value: "Cancel" }] });
var applyMessage = defineMessage({ id: "qj3Cr1", defaultMessage: [{ type: 0, value: "Apply" }] });

export { applyMessage, cancelMessage };
//# sourceMappingURL=messages.esm.js.map
